import React from "react";
import mug from "../../images/mug.png";

const Result = ({ result }) => {
  const { title, rules, gameKey } = result;

  return (
    <li className="Result">
      <a href={`/game/${gameKey}/card`}>
        <div>
          <h2>{title}</h2>
          <h3>{rules}</h3>
          <img src={mug} className="Result__mug" />
        </div>
      </a>
    </li>
  );
};

export default Result;
